import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { CongressDetailsForm } from "@/features/congress-details/components/congress-details-form";
import { DialogProps } from "@radix-ui/react-dialog";
import { useTranslation } from "react-i18next";

export function CreateCongressModal(props: DialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog {...props}>
      <DialogContent className="max-h-[90vh] max-w-2xl overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{t("common.newCongress")}</DialogTitle>
        </DialogHeader>
        <CongressDetailsForm onSuccess={() => props.onOpenChange?.(false)} />
      </DialogContent>
    </Dialog>
  );
}
